<template>
  <section class="discounts-list">
    <div class="container">
      <div
          class="row"
        >
        <div class="col-12 ">
          <div class="discounts-list__top  pb-4 mb-5">
            <slot />
          </div>
        </div>
      </div>

      <div class="discounts row">
        <div class="d-flex flex-wrap col-12">
          <div
            v-for="(discount, index) in discounts"
            :key="index"
            class="discount w-100 w-sm-50 w-md-33 w-lg-20 px-2 mb-3"
          >
            <router-link class="card" :to="getRoute(discount)">
              <div class="card-image" :style="{ backgroundImage: `url(${discount.image_url}` }"/>
              <div class="card-inner position-relative p-3">
                <header>
                  <h1>{{ discount.title }}</h1>
                </header>
                <div class="card-details">
                  <h4 class="date py-2">{{ timeFormat(discount.date) }}</h4>
                  <div v-if="discount.customData" class="price">
                    <h3
                      class="price-from d-inline"
                      v-if="discount.customData.price"
                    >
                      {{ priceFormat(discount.customData.price.old) }}
                    </h3>
                    <h2
                      class="price-to d-inline px-2"
                      :class="'color-' + discount.branche"
                      v-if="discount.customData.price"
                    >
                      {{ priceFormat(discount.customData.price.new) }}
                    </h2>
                  </div>
                  <button v-if="discount.pdfData" class="discount-btn text-white">Folder</button>
                </div>
                <div
                  class="card-category position-absolute text-center p-2"
                  :class="'bg-category-' + discount.branche"
                >
                  <i :class="brancheIcon(discount.branche)" class="text-white" />
                </div>
              </div>
            </router-link>
          </div>
          <p class="p-5 mx-auto text-center" v-if="discounts.length === 0"><i>Helaas, er zijn geen aanbiedingen gevonden.</i></p>
        </div>
        <div class="col-12 pagination justify-content-end d-flex flex-wrap">
          <span class="align-self-center font-weight-bold font-montserrat text-uppercase">Pagina</span>
          <el-pagination
            :page-size="pageSize"
            :total="total"
            layout="pager, slot"
            @current-change="changePage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Branche from '@/mixins/Branche'
import Utilities from '@/mixins/Utilities'
import Discounts from '@/mixins/Discounts'
import Formatting from '@/mixins/Formatting'

export default {
  name: 'ec-discount-list',
  mixins: [
    Branche,
    Utilities,
    Discounts,
    Formatting
  ],
  props: {
    discounts: Array,
    total: Number,
    pageSize: {
      type: Number,
      default: 10
    },
    changePage: Function
  },
  methods: {
    getRoute (discount) {
      const { info } = discount
      let route
      if (discount.customData) {
        route = { name: 'discountCustom', params: { discount: `${this.kebab(info.title)}-${info.id}`, slug: `${this.kebab(discount.title)}-${discount.customData.id}` } }
      } else {
        route = { name: 'discountPdf', params: { discount: `${this.kebab(info.title)}-${info.id}` } }
      }
      return route
    }
  }
}
</script>
